import React from 'react';
import { TextField, Button, Box, Typography } from '@mui/material';
import { useFormik } from 'formik';
import { businessSchema } from '../../utils/validationSchema';

interface BusinessFormProps {
  onSubmit: (values: { businessName: string; website?: string }) => void;
  onBack: () => void;
  initialValues?: {
    businessName: string;
    website?: string;
  };
}

const BusinessForm: React.FC<BusinessFormProps> = ({ onSubmit, onBack, initialValues }) => {
  const formik = useFormik({
    initialValues: initialValues || {
      businessName: '',
      website: ''
    },
    validationSchema: businessSchema,
    onSubmit: (values) => {
      onSubmit(values);
    }
  });

  return (
    <Box component="form" onSubmit={formik.handleSubmit} sx={{ maxWidth: 400, mx: 'auto', mt: 4 }}>
      <Typography variant="h5" component="h2" gutterBottom>
        Thông tin doanh nghiệp
      </Typography>

      <TextField
        fullWidth
        id="businessName"
        name="businessName"
        label="Tên doanh nghiệp"
        margin="normal"
        value={formik.values.businessName}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={formik.touched.businessName && Boolean(formik.errors.businessName)}
        helperText={formik.touched.businessName && formik.errors.businessName}
      />

      <TextField
        fullWidth
        id="website"
        name="website"
        label="Website (không bắt buộc)"
        margin="normal"
        value={formik.values.website}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={formik.touched.website && Boolean(formik.errors.website)}
        helperText={formik.touched.website && formik.errors.website}
      />

      <Box sx={{ mt: 3, display: 'flex', gap: 2 }}>
        <Button
          variant="outlined"
          color="primary"
          fullWidth
          size="large"
          onClick={onBack}
        >
          Quay lại
        </Button>
        <Button
          type="submit"
          variant="contained"
          color="primary"
          fullWidth
          size="large"
        >
          Tiếp theo
        </Button>
      </Box>
    </Box>
  );
};

export default BusinessForm; 